"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueTilesRedesign = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const react_router_dom_1 = require("react-router-dom");
const react_multi_carousel_1 = __importDefault(require("react-multi-carousel"));
require("react-multi-carousel/lib/styles.css");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const WeatherTile_1 = __importDefault(require("./WeatherTile"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const TileRedesign_1 = __importDefault(require("./TileRedesign"));
const globalVariables_1 = require("../../../common/globalVariables");
const Wrapper = styled_components_1.default.div `
  padding: 0 16px;
  position: relative;
  margin: 30px auto 10px;
  max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;

  @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_WITH_BUTTONS}px) {
    padding: 0;
  }

  .carousel-content {
    position: inherit;
  }

  .react-multi-carousel-item {
    margin-bottom: 23px;

    @media (min-width: 1024px) {
      margin-bottom: 16px;
    }
  }

  .react-multi-carousel-dot-list {
    .react-multi-carousel-dot--active button {
      background: ${(props) => props.theme.palette.mainAppColor.main};
    }

    button {
      background: #c7c4bd;
      border: none;
      height: 8px;
      width: 8px;
    }

    bottom: 8px;
  }

  .row-tiles {
    display: flex;
    flex-wrap: wrap;
    justify-content: ${(props) => props.tilesNumber < props.tilesPerRow / 2 ? "center" : "normal"};
  }
`;
const VenueTilesRedesign = (props) => {
    const { userData, history, baseUrl, showCheckout, navigations, weatherData, venue, } = props;
    const isBareissBrand = venue && venue.brandSlug === "bareiss";
    const [isMoving, setIsMoving] = (0, react_1.useState)(false);
    const [tilesPerRow, setTilesPerRow] = (0, react_1.useState)(calculateTilesPerRow());
    const wrapperRef = (0, react_1.useRef)(null);
    const dragX = (0, react_1.useRef)(0);
    const dragY = (0, react_1.useRef)(0);
    const lockedHorizontalScroll = (0, react_1.useRef)(false);
    const windowWidth = (0, react_1.useRef)(window.innerWidth);
    const responsiveTilesCarousel = {
        desktop: {
            breakpoint: { max: 3000, min: 1023 },
            items: 1,
            slidesToSlide: 1,
        },
        tablet: {
            breakpoint: { max: 1023, min: 767 },
            items: 1,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 767, min: 320 },
            items: 1,
            slidesToSlide: 1,
        },
    };
    const handleResize = () => {
        if (windowWidth.current !== window.innerWidth) {
            setTilesPerRow(calculateTilesPerRow());
            windowWidth.current = window.innerWidth;
        }
    };
    const handleTouch = (evt) => {
        dragX.current = evt.touches[0].clientX;
        dragY.current = evt.touches[0].clientY;
    };
    const handleTouchEnd = () => {
        if (lockedHorizontalScroll.current) {
            const body = document.querySelector("body");
            if (body) {
                body.style.overflow = "visible";
            }
            lockedHorizontalScroll.current = false;
        }
    };
    const handleTouchMove = (evt) => {
        const distanceX = Math.abs(evt.touches[0].clientX - dragX.current);
        if (distanceX >= 5 && !lockedHorizontalScroll.current) {
            const body = document.querySelector("body");
            if (body) {
                body.style.overflow = "hidden";
            }
            // preventing default to get safari to stop the scroll, the "hidden" overflow from above does not work on safari
            evt.preventDefault();
            lockedHorizontalScroll.current = true;
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener("resize", handleResize);
        if (wrapperRef && wrapperRef.current) {
            wrapperRef.current.addEventListener("touchstart", handleTouch);
            wrapperRef.current.addEventListener("touchmove", handleTouchMove);
            wrapperRef.current.addEventListener("touchend", handleTouchEnd);
        }
        return () => {
            window.removeEventListener("resize", handleResize);
            if (wrapperRef && wrapperRef.current) {
                wrapperRef.current.removeEventListener("touchstart", handleTouch);
                wrapperRef.current.removeEventListener("touchmove", handleTouchMove);
                wrapperRef.current.removeEventListener("touchend", handleTouchEnd);
            }
        };
    }, []);
    const checkout = () => {
        if (isMoving) {
            return;
        }
        apiService_1.default.checkoutUser(userData.token);
        const currentThemeFont = document.getElementById("theme-font");
        if (currentThemeFont) {
            currentThemeFont.remove();
        }
        history.push({
            pathname: "/",
        });
    };
    let tileCounter = -1;
    const countImageTiles = true;
    const renderTiles = (isMovingParameter, tiles) => tiles
        .map((navigation) => {
        switch (navigation.type) {
            case "weather":
                if (Object.keys(weatherData).length > 0) {
                    tileCounter += 1;
                    return (react_1.default.createElement(WeatherTile_1.default, { position: tileCounter, key: (0, react_uid_1.uid)(navigation), isBareissBrand: isBareissBrand }));
                }
                return null;
            // the tink to settings( preferences ) will be moved to the header, therefore we don't display this tile here anymore
            case "preferences":
                return null;
            // case "preferences":
            //     tileCounter += 1;
            //     return (
            //         <TileRedesign
            //             withIcon
            //             svg={ navigation.icon }
            //             title={ navigation.title }
            //             destination={ {
            //                 url: `${ baseUrl }/settings`,
            //                 type: "internal",
            //             } }
            //             position={ tileCounter }
            //             withBackgroundImage={ !!( navigation.payload && navigation.payload.imageUrl ) }
            //             image={ navigation.payload ? navigation.payload.imageUrl : "" }
            //             key={ uid( navigation ) }
            //             isMovingCarousel={ isMovingParameter }
            //             isBareissBrand={ isBareissBrand }
            //         />
            //     );
            case "checkout":
                if (showCheckout) {
                    tileCounter += 1;
                    return (react_1.default.createElement(TileRedesign_1.default, { key: (0, react_uid_1.uid)(navigation), withIcon: true, svg: navigation.icon, title: navigation.title, position: tileCounter, withBackgroundImage: !!(navigation.payload && navigation.payload.imageUrl), image: navigation.payload ? navigation.payload.imageUrl : "", isMovingCarousel: isMovingParameter, isBareissBrand: isBareissBrand, onTileClick: () => checkout() }));
                }
                return null;
            case "kids_club":
            case "pinboard":
            case "radio":
            case "doorlock":
            case "voting":
            case "language":
            case "spa_bookings":
                return null;
            case "internal_browser":
            case "external_browser":
                if (countImageTiles) {
                    tileCounter += 1;
                }
                return (react_1.default.createElement(TileRedesign_1.default, { withIcon: true, svg: navigation.icon, withBackgroundImage: true, image: navigation.payload ? navigation.payload.imageUrl : "", title: navigation.title, position: tileCounter, destination: {
                        url: navigation.payload ? navigation.payload.url : "",
                        type: "external",
                    }, key: (0, react_uid_1.uid)(navigation), isMovingCarousel: isMovingParameter, isBareissBrand: isBareissBrand }));
            case "deeplink":
                if (countImageTiles) {
                    tileCounter += 1;
                }
                return (react_1.default.createElement(TileRedesign_1.default, { withIcon: true, svg: navigation.icon, withBackgroundImage: true, image: navigation.payload ? navigation.payload.imageUrl : "", title: navigation.title, position: tileCounter, destination: {
                        url: navigation.payload ? navigation.payload.url : "",
                        type: "deeplink",
                    }, key: (0, react_uid_1.uid)(navigation), isMovingCarousel: isMovingParameter, isBareissBrand: isBareissBrand }));
            case "guest_journey_checkin":
                tileCounter += 1;
                return (react_1.default.createElement(TileRedesign_1.default, { withIcon: true, svg: navigation.icon, title: navigation.title, destination: {
                        url: `${baseUrl}/guest_journey`,
                        type: "internal",
                    }, position: tileCounter, withBackgroundImage: !!(navigation.payload && navigation.payload.imageUrl), image: navigation.payload ? navigation.payload.imageUrl : "", key: (0, react_uid_1.uid)(navigation), isMovingCarousel: isMovingParameter, isBareissBrand: isBareissBrand }));
            case "experience_platform":
                if (countImageTiles) {
                    tileCounter += 1;
                }
                return (react_1.default.createElement(TileRedesign_1.default, { withIcon: true, svg: navigation.icon, withBackgroundImage: true, image: navigation.payload ? navigation.payload.imageUrl : "", title: navigation.title, position: tileCounter, destination: {
                        url: `${baseUrl}/experience-platform`,
                        type: "internal",
                    }, key: (0, react_uid_1.uid)(navigation), isMovingCarousel: isMovingParameter, isBareissBrand: isBareissBrand }));
            default:
                tileCounter += 1;
                return (react_1.default.createElement(TileRedesign_1.default, { navType: navigation.type, withIcon: true, svg: navigation.icon, title: navigation.title, destination: {
                        url: `${baseUrl}/${navigation.type}`,
                        type: "internal",
                    }, position: tileCounter, withBackgroundImage: !!(navigation.payload && navigation.payload.imageUrl), image: navigation.payload ? navigation.payload.imageUrl : "", key: (0, react_uid_1.uid)(navigation), isMovingCarousel: isMovingParameter, isBareissBrand: isBareissBrand }));
        }
    })
        .filter((tile) => tile !== null);
    const renderTileRows = (isMovingParameter, tilesArray, tilesPerRowParameter) => {
        const tileRows = [];
        for (let i = 0; i < tilesArray.length; i += tilesPerRowParameter) {
            const rowTiles = tilesArray.slice(i, i + tilesPerRowParameter);
            const tileRow = (react_1.default.createElement(material_1.Box, { key: (0, react_uid_1.uid)(i), className: "row-tiles" }, renderTiles(isMovingParameter, rowTiles)));
            tileRows.push(tileRow);
        }
        return tileRows;
    };
    // I created this variable because I want to remove all entries for which we return null in the renderTiles function
    const filteredTiles = navigations.homePage.filter((navigation) => {
        if (navigation.type === "weather" &&
            !(Object.keys(weatherData).length > 0)) {
            return null;
        }
        if (navigation.type === "checkout" && !showCheckout) {
            return null;
        }
        return ![
            "kids_club",
            "pinboard",
            "radio",
            "doorlock",
            "voting",
            "language",
            "spa_bookings",
            "preferences",
        ].includes(navigation.type);
    });
    const tileRows = renderTileRows(isMoving, filteredTiles, tilesPerRow);
    return (react_1.default.createElement(Wrapper, { tilesNumber: filteredTiles.length, tilesPerRow: tilesPerRow },
        react_1.default.createElement(material_1.Box, { className: "carousel-wrapper", ref: wrapperRef },
            react_1.default.createElement(react_multi_carousel_1.default, { minimumTouchDrag: 5, arrows: false, showDots: tilesPerRow < filteredTiles.length, renderDotsOutside: true, swipeable: true, draggable: true, responsive: responsiveTilesCarousel, keyBoardControl: true, containerClass: "carousel-content", beforeChange: () => {
                    setIsMoving(true);
                }, afterChange: () => {
                    setIsMoving(false);
                } }, tileRows))));
};
exports.VenueTilesRedesign = VenueTilesRedesign;
const mapStoreToProps = (store) => ({
    baseUrl: store.getValue("baseUrl"),
    userData: store.getValue("userData"),
    venue: store.getValue("venue"),
    navigations: store.getValue("navigations"),
    showCheckout: store.getValue("showCheckout"),
    weatherData: store.getValue("weather"),
});
function calculateTilesPerRow() {
    let tilesPerRow;
    if (window.innerWidth >= 320 && window.innerWidth < 500) {
        tilesPerRow = 8;
    }
    else if (window.innerWidth >= 500 && window.innerWidth < 744) {
        tilesPerRow = 12;
    }
    else if (window.innerWidth >= 744 && window.innerWidth < 1024) {
        tilesPerRow = 16;
    }
    else {
        tilesPerRow = 20;
    }
    return tilesPerRow;
}
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.VenueTilesRedesign));
